const FR_SHORT: Intl.DateTimeFormatOptions = {
  dateStyle: 'short',
  timeStyle: 'short',
};

const FR_MEDIUM_SHORT: Intl.DateTimeFormatOptions = {
  dateStyle: 'medium',
  timeStyle: 'short',
};

/** Date/heure courte locale `fr-FR` ; valeur absente ou invalide → `—`. */
export function formatDateTimeFrShort(
  iso: Date | string | null | undefined
): string {
  if (iso == null || iso === '') return '—';
  try {
    return new Date(iso).toLocaleString('fr-FR', FR_SHORT);
  } catch {
    return '—';
  }
}

/** Date moyenne + heure courte `fr-FR` (ex. entêtes de fiche) ; invalide → `—`. */
export function formatDateTimeFrMediumShort(
  iso: Date | string | null | undefined
): string {
  if (iso == null || iso === '') return '—';
  try {
    const d = typeof iso === 'string' ? new Date(iso) : iso;
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleString('fr-FR', FR_MEDIUM_SHORT);
  } catch {
    return '—';
  }
}

/** Jour et mois numériques `fr-FR` (souvent axes de graphiques). Invalide → chaîne vide. */
export function formatDateFrDayMonth(value: string | Date): string {
  try {
    const d = typeof value === 'string' ? new Date(value) : value;
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
    });
  } catch {
    return '';
  }
}

/** Date seule format court `fr-FR` (équivalent usage courant de `toLocaleDateString('fr-FR')`). */
export function formatDateFrShort(
  iso: Date | string | null | undefined
): string {
  if (iso == null || iso === '') return '—';
  try {
    const d = typeof iso === 'string' ? new Date(iso) : iso;
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('fr-FR', { dateStyle: 'short' });
  } catch {
    return '—';
  }
}

/** Date seule format moyen (infobulles, libellés complets sans heure). */
export function formatDateFrMedium(
  iso: Date | string | null | undefined
): string {
  if (iso == null || iso === '') return '—';
  try {
    const d = typeof iso === 'string' ? new Date(iso) : iso;
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('fr-FR', { dateStyle: 'medium' });
  } catch {
    return '—';
  }
}

/** Jour mois court (axe X). Invalide → chaîne vide. */
export function formatDateFrDayNumericMonthShort(
  value: string | Date
): string {
  try {
    const d = typeof value === 'string' ? new Date(value) : value;
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString('fr-FR', {
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return '';
  }
}

/** Jour (2 chiffres) + mois court (axe X). Invalide → chaîne vide. */
export function formatDateFrDay2MonthShort(value: string | Date): string {
  try {
    const d = typeof value === 'string' ? new Date(value) : value;
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'short',
    });
  } catch {
    return '';
  }
}

/** Jour + mois abrégé + année (fiches leçon, etc.). */
export function formatDateFrNumericDMY(
  iso: Date | string | null | undefined
): string {
  if (iso == null || iso === '') return '—';
  try {
    const d = typeof iso === 'string' ? new Date(iso) : iso;
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return '—';
  }
}

/** Jour + mois long + année (naissance, métadonnées). */
export function formatDateFrLong(iso: Date | string | null | undefined): string {
  if (iso == null || iso === '') return '—';
  try {
    const d = typeof iso === 'string' ? new Date(iso) : iso;
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  } catch {
    return '—';
  }
}

/** Mois abrégé + année (« Depuis avr. 2024 »). */
export function formatDateFrMonthYear(
  iso: Date | string | null | undefined
): string {
  if (iso == null || iso === '') return '—';
  try {
    const d = typeof iso === 'string' ? new Date(iso) : iso;
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('fr-FR', {
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return '—';
  }
}
